module.exports = __webpack_public_path__ + "static/media/mosmetro_sign_otr.d96d860b.svg";